import React, { Component } from "react";
import './pretty-number-tab.less'
// 工具
import { isiOS } from '@/utils/common';

interface Props {
  prettyNumber: string;
}

interface State {
  width: number;
}

const numberWidth = () => {
  const id = document.getElementById('prettyNumberRef') as HTMLElement
  if (id?.offsetWidth) {
    let coefficient = id.offsetWidth * 0.3
    const difference = isiOS ? 31 : 26
    return id.offsetWidth + (coefficient < difference ? difference : coefficient)
  }
  return 71
}

export default class PrettyNumberTab extends Component<Props, State> {
  refs: any = React.createRef()
  constructor(props: Props) {
    super(props)

    this.state = {
      width: 71
    }
  }

  componentDidMount() {
    this.setState({ width: numberWidth() })
  }

  render() {
    return (
      <div className={isiOS ? 'ID-content' : 'andriod-ID-content'}>
        <div className="ID" style={{width: `${numberWidth()}px`}}>
          <div className="box-content">
            <span id="prettyNumberRef">{this.props.prettyNumber}</span>
          </div>
        </div>
      </div>
    )
  }
}